import { render, staticRenderFns } from "./FaQManagementView.vue?vue&type=template&id=9f71a862&"
import script from "./FaQManagementView.vue?vue&type=script&lang=js&"
export * from "./FaQManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports